import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { LoginComponent } from './auth/login/login.component';

import { BuyModule } from './public/buy/buy.module';
import { HomeModule } from './public/home/home.module';
import { InsureModule } from './public/insure/insure.module';
import { KeepModule } from './public/keep/keep.module';
import { RentModule } from './public/rent/rent.module';
import { SupportModule } from './public/support/support.module';
import { AdminModule } from './sessions/admin/admin.module';
import { CustomerModule } from './sessions/customer/customer.module';
import { OwnerModule } from './sessions/owner/owner.module';
import { ProviderModule } from './sessions/provider/provider.module';
import { DealerModule } from './sessions/dealer/dealer.module';
import { AccessDeniedComponent } from './auth/access-denied/access-denied.component';
import { AuthGuard } from './auth/auth.guard';
import { NotFoundComponent } from './auth/not-found/not-found.component';
import { DealerPublicComponent } from './sessions/dealer/dealer-public/dealer-public.component';
import { AboutModule } from './public/about/about.module';
import { DealerBuyModule } from './sessions/dealer-buy/dealer-buy.module';
import { DealerAccountModule } from './sessions/dealer-account/dealer-account.module';
import { DealerSellModule } from './sessions/dealer-sell/dealer-sell.module';
import { DealerCarModule } from './sessions/dealer-car/dealer-car.module';
import { DealerExchangeModule } from './sessions/dealer-exchange/dealer-exchange.module';
import { DealerIntermediationModule } from './sessions/dealer-intermediation/dealer-intermediation.module';
import { DealerRentInModule } from './sessions/dealer-rent-in/dealer-rent-in.module';
import { DealerRentOutModule } from './sessions/dealer-rent-out/dealer-rent-out.module';
import { DealerRepairModule } from './sessions/dealer-repair/dealer-repair.module';
import { DealerControlModule } from './sessions/dealer-control/dealer-control.module';
import { DealerCommunicationModule } from './sessions/dealer-communication/dealer-communication.module';
import { DealerTransactionModule } from './sessions/dealer-transaction/dealer-transaction.module';
import { CustomerDashboardComponent } from './sessions/customer/customer-dashboard/customer-dashboard.component';
import { appRoutes, AppRoute } from './app.routes';
import { DealerPostingModule } from './sessions/dealer-posting/dealer-posting.module';

const appRoutesOld: Routes = [
  //{ path: '', redirectTo: '/login', pathMatch: 'full' },
  //{ path: '', redirectTo: '/buy-car', pathMatch: 'full' },
  //{ path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },



  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [AuthGuard],
  },

  {
    path: '',
    //canActivate: [AuthGuard],
    loadChildren: () => HomeModule ,
    //loadChildren: () => BuyCarModule ,
  },

  { path: 'provider-public', component: DealerPublicComponent },

  {
    path: 'buy',
    //canActivate: [AuthGuard],
    loadChildren: () => BuyModule ,
  },

  {
    path: 'rent', 
    //canActivate: [AuthGuard],
    loadChildren: () => RentModule,
  },

  {
    path: 'insure', 
    //canActivate: [AuthGuard],
    loadChildren: () => InsureModule,
  },
  
  {
    path: 'keep', 
    //canActivate: [AuthGuard],
    loadChildren: () => KeepModule,
  },

  {
    path: 'support',
    //canActivate: [AuthGuard],
    loadChildren: () => SupportModule,
  },

  {
    path: 'about',
    //canActivate: [AuthGuard],
    loadChildren: () => AboutModule,
  },

  {
    path: 'customer',
    //canActivate: [AuthGuard],
    loadChildren: () => CustomerModule,
  },

  {
    path: 'owner',
    //canActivate: [AuthGuard],
    loadChildren: () => OwnerModule,
  },

  {
    path: 'provider',
    //canActivate: [AuthGuard],
    loadChildren: () => ProviderModule,
  },

  {
    path: 'admin',
    //canActivate: [AuthGuard],
    loadChildren: () => AdminModule,
    canActivate: [AuthGuard],
    //data: { roles: ['ADMIN', 'DEALER'] },
  },

  {
    path: 'dealer',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerModule,
  },

  /*
  {
    path: 'buy-car',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/buy-car/buy-car.module').then((m) => m.BuyCarModule),
  },
  {
    path: 'sell-car', 
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/sell-car/sell-car.module').then((m) => m.SellCarModule),
  },
  
  {
    path: 'support',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/support/support.module').then((m) => m.SupportModule),
  },

  {
    path: 'account',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/account/account.module').then((m) => m.AccountModule),
  },
  */

  { path: 'dashboard', canActivate: [AuthGuard], component: CustomerDashboardComponent },
  {
    path: 'car',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerCarModule,
  },
  {
    path: 'posting',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerPostingModule,
  },
  {
    path: 'buy-in',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerBuyModule,
  },
  {
    path: 'exchange',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerExchangeModule,
  },
  {
    path: 'intermediation',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerIntermediationModule,
  },
  {
    path: 'sell',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerSellModule,
  },
  {
    path: 'rent-in',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerRentInModule,
  },
  {
    path: 'rent-out',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerRentOutModule,
  },

  {
    path: 'repair',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerRepairModule,
  },

  {
    path: 'control',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerControlModule,
  },

  {
    path: 'communication',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerCommunicationModule,
  },

  {
    path: 'transactions',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerTransactionModule,
  },

  {
    path: 'account',
    //canActivate: [AuthGuard],
    loadChildren: () => DealerAccountModule,
  },

  { path: 'not-found', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent },
];


function mapRoutes(routes: AppRoute[]): Routes {
  return routes.map(r => {
    const route: any = { path: r.path };
    if (r.loadChildren) route.loadChildren = r.loadChildren;
    if (r.children) route.children = mapRoutes(r.children);
    return route;
  });
}

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64],
};


@NgModule({
  imports: [RouterModule.forRoot( appRoutesOld, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
